import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { rpc } from "@/lib/supabase";
import { PageHeader, EmptyState, Loader } from "@/components/kit";
import { ServiceCard } from "@/components/ServiceCard";

export default function BusinessHistory() {
  const [list, setList] = useState(null);
  useEffect(() => {
    rpc("get_business_services", { p_only_active: false })
      .then((d) => setList((d || []).filter((s) => ["DELIVERED", "CANCELLED"].includes(s.status))))
      .catch(() => setList([]));
  }, []);

  if (list === null) return <Loader />;
  return (
    <div>
      <PageHeader title="Historial" subtitle="Envíos entregados y cancelados." testId="business-history" />
      {list.length === 0 ? (
        <EmptyState icon={History} title="Sin historial todavía" subtitle="Tus envíos finalizados aparecerán aquí." testId="empty-history" />
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {list.map((s) => (
            <ServiceCard key={s.id} s={s} to={`/business/service/${s.id}`} testId={`history-${s.id}`} />
          ))}
        </div>
      )}
    </div>
  );
}
